































































































































































































































































































































































































import { collapseMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import {
  GeekItem,
  ActivityType,
  ActivityHistory,
  ActivityGroup,
  Geek,
  ActivityHistoryStatusType,
  TranslatedActivityType,
} from '@/models';
import { AllGeeksSingleSelect, DeleteActivityModal } from '@/components';
import { Multiselect } from 'vue-multiselect';
import { Actions, typedStore } from '@/store';
import { buildGeekName } from '@/utils';
import moment from 'moment';
import ActivityIcon from '@/components/core/ActivityIcon.vue';
import {debounce} from 'lodash';

export default mixins(collapseMixin).extend({
  name: 'ActivitiesHistoryTab',
  components: {
    ActivityIcon,
    AllGeeksSingleSelect,
    Multiselect,
    DeleteActivityModal,
  },
  data() {
    return {
      activityHistoryStatusType: ActivityHistoryStatusType,
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      filters: {
        immediate: {
          requestedForId: (null as unknown) as string,
          requestedById: (null as unknown) as string,
          activityTypeId: (null as unknown) as number,
          status: ActivityHistoryStatusType.Unknown,
          reason: (null as unknown) as string,
        },
      },
      activityType: (null as unknown) as ActivityType,
      deletedActivity: (null as unknown) as ActivityHistory,
      statusTypes: {
        accepted: ActivityHistoryStatusType.Accepted,
        rejected: ActivityHistoryStatusType.Rejected,
        addedByAdmin: ActivityHistoryStatusType.AddedByAdmin,
      },
      statusSelect: ['accepted', 'rejected', 'added-by-admin'],
      loader: {
        isActivityHistoryPending: false,
      },
    };
  },
  async mounted(): Promise<void> {
    await this.fetchAllActivities();
    await this.fetchActivitiesHistory();
  },
  computed: {
    collapsibleItems(): ActivityHistory[] {
      return typedStore(this).state.activities.activitiesHistory;
    },
    activitiesHistoryCount(): number {
      return typedStore(this).state.activities.pagination.totalCount;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < this.activitiesHistoryCount && this.collapsibleItems.length > 0;
    },
    activities(): ActivityGroup[] {
      return typedStore(this).state.activities.all.map(activityGroup => {
        return {
          skill: activityGroup.skill,
          activityTypes: activityGroup.activityTypes.map(activityType => {
            return {
              ...activityType,
              translatedName: this.$t(`activity.types.${activityType.name}.name`),
            } as TranslatedActivityType;
          }),
        } as ActivityGroup;
      });
    },
    currentUser(): Geek {
      return typedStore(this).state.geek.current;
    },
  },
  methods: {
    async fetchAllActivities(): Promise<void> {
      try {
        await this.$store.dispatch(Actions.activities.fetchAll);
      } finally {
        // ignored
      }
    },
    async fetchActivitiesHistory(): Promise<void> {
      this.loader.isActivityHistoryPending = true;

      try {
        await this.$store.dispatch(Actions.activities.fetchActivitiesHistory, this.filters.immediate);
      } finally {
        this.loader.isActivityHistoryPending = false;
      }
    },
    async fetchMoreActivitiesHistory(): Promise<void> {
      this.loader.isActivityHistoryPending = true;

      try {
        await this.$store.dispatch(Actions.activities.fetchMoreActivitiesHistory, this.filters.immediate);
      } finally {
        this.loader.isActivityHistoryPending = false;
      }
    },
    updateRequestedFor(selectedGeek: GeekItem) {
      this.filters.immediate.requestedForId = selectedGeek ? selectedGeek.id : ((null as unknown) as string);
    },
    updateRequestBy(selectedGeek: GeekItem) {
      this.filters.immediate.requestedById = selectedGeek ? selectedGeek.id : ((null as unknown) as string);
    },
    updateActivity(selectedActivity: ActivityType) {
      this.activityType = selectedActivity;
      this.filters.immediate.activityTypeId = selectedActivity ? selectedActivity.id : ((null as unknown) as number);
    },
    updateStatus(selectedStatus: ActivityHistoryStatusType) {
      this.filters.immediate.status = selectedStatus;
    },
    getFullName(geek: GeekItem): string {
      return buildGeekName(geek);
    },
    formattedDateTime(date: Date): string {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
    isSubType(activity: ActivityHistory): number {
      return activity.subtype ? activity.subtype.rewardGxp : activity.type.gxp;
    },
    clearSelectedActivityType() {
      this.activityType = (null as unknown) as ActivityType;
      this.filters.immediate.activityTypeId = ((null as unknown) as number);
    },
    clearSelectedStatus() {
      this.filters.immediate.status = (null as unknown) as ActivityHistoryStatusType;
    },
    async deleteGeekActivity(activity: ActivityHistory) {
      this.deletedActivity = activity;
      this.$bvModal.show('delete-activity-modal');
    },
    updateReasonSearch: debounce(function(this: any) {
      this.filters.immediate.reason = this.$refs.searchReason.$el.value;
    }, 1000),
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchActivitiesHistory();
      },
      deep: true,
    },
  },

});
